export default __webpack_public_path__ + "static/media/liftweb.22540732.svg";